import { render } from "./PageAlert.vue?vue&type=template&id=21fd2ca0"
import script from "./PageAlert.vue?vue&type=script&lang=js"
export * from "./PageAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__